<script setup>
import {
  Collapsible,
} from '@/components/ui/collapsible';
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';
import { useViewStore } from '@/stores/viewStore'

import { computed } from 'vue'
import { Square } from 'lucide-vue-next';

const props = defineProps({
  items: { type: Array, required: true },
  projects: { type: Array, required: true },
  actionView: String,
  label: String,
  view: String
});

const activeProjects = computed(() =>
  props.projects.filter(p => p.status === 0)
)
const optionalProjects = computed(() =>
  props.projects.filter(p => p.status === 2)
)



const viewStore = useViewStore()

const setView = () => {
  viewStore.setActionView(props.view)
}
</script>

<template>
    <SidebarMenu>
      <Collapsible
        v-for="item in items"
        :key="item.title"
        as-child
        :default-open="item.isActive"
        class="group/collapsible"
      >
        <SidebarMenuItem>
            <SidebarMenuButton @click="viewStore.setActionView(item.url)"  :tooltip="item.title"  :isActive="viewStore.actionView === item.url">				
				<component :is="item.icon" v-if="item.icon" />
				<span>{{ item.title }}</span>
            </SidebarMenuButton>
        </SidebarMenuItem>
      </Collapsible>
    </SidebarMenu>
</template>
